import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AutoCompleteKeyword, AutoCompleteKeywordUpdate } from "@/model";
import autoCompleteKeywordRepository from "@/repository/autoCompleteKeywordRepository";


export const useUpdateAutocompleteKeyword = (agentId: number, autocompleteId: string, autocompleteKeywordId: string) => {
    const queryClient = useQueryClient();

    return useMutation<AutoCompleteKeyword, AxiosError, AutoCompleteKeywordUpdate>({
        mutationKey: [agentId, 'autocomplete-keyword', 'update'],
        mutationFn: async (body: AutoCompleteKeywordUpdate) => {
            try {
                const { data } = await autoCompleteKeywordRepository.update(agentId, autocompleteId,autocompleteKeywordId, body);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["autocomplete-keyword"]
            });
        }
    });
};
